<template>
    <div class="login-container">
        <div class="login-wrapper">
            <!-- 左侧品牌与服务展示区 -->
            <div class="brand-section">
                <!-- Logo和网站名称 -->
                <div class="brand-header">
                    <div class="logo">
                        <i class="icon-rocket"></i>
                    </div>
                    <h1 class="brand-name">趣千川</h1>
                </div>

                <!-- 品牌与服务核心价值 -->
                <div class="brand-content">
                    <h2 class="brand-slogan">
                        全域运营难题，<br>一站式解决
                    </h2>

                    <!-- 服务亮点卡片 -->
                    <div class="features">
                        <div class="feature-card">
                            <i class="icon-line-chart"></i>
                            <div class="feature-info">
                                <h3 class="feature-title">投放效率倍增</h3>
                                <p class="feature-desc">自动追投爆款，低效投放智能关停</p>
                            </div>
                        </div>

                        <div class="feature-card">
                            <i class="icon-balance-scale"></i>
                            <div class="feature-info">
                                <h3 class="feature-title">ROI精准把控</h3>
                                <p class="feature-desc">全域投产实时监控，自动调整优化目标</p>
                            </div>
                        </div>

                        <div class="feature-card">
                            <i class="icon-sitemap"></i>
                            <div class="feature-info">
                                <h3 class="feature-title">多账户高效管理</h3>
                                <p class="feature-desc">矩阵号统一管控，全域账户批量搭建</p>
                            </div>
                        </div>

                        <div class="feature-card">
                            <i class="icon-bar-chart"></i>
                            <div class="feature-info">
                                <h3 class="feature-title">素材与权限可控</h3>
                                <p class="feature-desc">全域素材数据同步，团队权限精细隔离</p>
                            </div>
                        </div>
                    </div>

                    <p class="brand-description">
                        为电商、品牌方提供全域运营解决方案，让团队聚焦创意与策略，而非繁琐操作
                    </p>
                </div>

                <!-- 底部链接 -->
                <!-- <div class="brand-footer">
                    <div class="social-links">
                        <a href="#" class="social-icon" title="微博">
                            <i class="icon-weibo"></i>
                        </a>
                        <a href="#" class="social-icon" title="微信">
                            <i class="icon-wechat"></i>
                        </a>
                        <a href="#" class="help-link">
                            <i class="icon-question-circle"></i>
                            <span>帮助中心</span>
                        </a>
                    </div>
                </div> -->
            </div>

            <!-- 右侧登录表单区 -->
            <div class="login-section" v-if="userType == '登录'">
                <div class="login-header">
                    <h2 class="login-title">欢迎登录</h2>
                    <p class="login-subtitle">请使用账号登录，开启高效运营</p>
                </div>

                <!-- 登录方式切换 -->
                <div class="login-tabs">
                    <button class="tab-btn" :class="{ active: loginType === 'password' }"
                        @click="switchLoginType('password')">
                        密码登录
                    </button>
                    <button class="tab-btn" :class="{ active: loginType === 'sms' }" @click="switchLoginType('sms')">
                        短信登录
                    </button>
                </div>

                <!-- 密码登录表单 -->
                <form class="login-form" v-if="loginType === 'password'" @submit.prevent="handleLogin">
                    <div class="form-group">
                        <label for="username" class="form-label">账号/手机号</label>
                        <div class="input-wrapper">
                            <i class="icon-user"></i>
                            <input type="text" id="username" v-model="loginForm.username" class="form-input"
                                placeholder="请输入账号或手机号" required>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="form-label-wrapper">
                            <label for="password" class="form-label">密码</label>
                            <!-- <a href="#" class="forgot-link">忘记密码？</a> -->
                        </div>
                        <div class="input-wrapper">
                            <i class="icon-lock"></i>
                            <input :type="showPassword ? 'text' : 'password'" id="password" v-model="loginForm.password"
                                class="form-input" placeholder="请输入密码" required>
                            <button type="button" class="toggle-password" @click="togglePasswordVisibility">
                                <!-- <i :class="showPassword ? 'icon-eye' : 'icon-eye-slash'"></i> -->
                            </button>
                        </div>
                    </div>

                    <button type="submit" class="login-btn" :disabled="isLoading">
                        <span>登录</span>
                        <i class="icon-arrow-right"></i>
                        <div v-if="isLoading" class="loading-spinner"></div>
                    </button>
                </form>

                <!-- 短信登录表单 -->
                <form class="login-form" v-if="loginType === 'sms'" @submit.prevent="handleSmsLogin">
                    <div class="form-group">
                        <label for="phone" class="form-label">手机号</label>
                        <div class="input-wrapper">
                            <i class="icon-mobile"></i>
                            <input type="tel" id="phone" v-model="smsForm.phone" class="form-input" placeholder="请输入手机号"
                                required>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="smsCode" class="form-label">短信验证码</label>
                        <div class="input-wrapper">
                            <i class="icon-shield"></i>
                            <input type="text" id="smsCode" v-model="smsForm.code" class="form-input"
                                placeholder="请输入验证码" required>
                            <button type="button" class="get-code-btn" @click="getSmsCode"
                                :disabled="isSendingCode || !smsForm.phone">
                                {{ codeButtonText }}
                            </button>
                        </div>
                    </div>

                    <button type="submit" class="login-btn" :disabled="isLoading">
                        <span>登录</span>
                        <i class="icon-arrow-right"></i>
                        <div v-if="isLoading" class="loading-spinner"></div>
                    </button>
                </form>

                <!-- 底部注册入口 -->
                <div class="register-section">
                    <p class="register-text">
                        还没有账号？<a href="#" class="register-link"
                            @click="userType = '注册'; codeCountdown = 0; smsForm = { phone: '', code: '' }">立即注册</a>
                    </p>
                </div>
            </div>
            <div class="login-section" v-else>
                <div class="login-header">
                    <h2 class="login-title">欢迎注册</h2>
                    <p class="login-subtitle">请使用账号注册，开启高效运营</p>
                </div>

                <!-- 登录方式切换 -->
                <div class="login-tabs">
                    <button class="tab-btn" :class="{ active: true }" @click="switchLoginType('password')">
                        注册
                    </button>
                </div>
                <!-- 短信登录表单 -->
                <form class="login-form" @submit.prevent="handleSmsRegister">
                    <div class="form-group">
                        <label for="phone" class="form-label">手机号</label>
                        <div class="input-wrapper">
                            <i class="icon-mobile"></i>
                            <input type="tel" id="phone" v-model="smsForm.phone" class="form-input" placeholder="请输入手机号"
                                required>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="smsCode" class="form-label">短信验证码</label>
                        <div class="input-wrapper">
                            <i class="icon-shield"></i>
                            <input type="text" id="smsCode" v-model="smsForm.code" class="form-input"
                                placeholder="请输入验证码" required>
                            <button type="button" class="get-code-btn" @click="getSmsCode"
                                :disabled="isSendingCode || !smsForm.phone">
                                {{ codeButtonText }}
                            </button>
                        </div>
                    </div>

                    <button type="submit" class="login-btn" :disabled="isLoading">
                        <span>注册</span>
                        <i class="icon-arrow-right"></i>
                        <div v-if="isLoading" class="loading-spinner"></div>
                    </button>
                </form>

                <!-- 底部注册入口 -->
                <div class="register-section">

                    <p class="register-text">
                        已有账号？<a href="#" class="register-link"
                            @click="userType = '登录'; codeCountdown = 0; smsForm = { phone: '', code: '' }">立即登录</a>
                    </p>
                </div>
            </div>
        </div>

        <!-- 提示弹窗 -->
        <div v-if="showAlert" class="alert-modal">
            <div class="alert-content">
                <h3 class="alert-title">{{ alertTitle }}</h3>
                <p class="alert-message">{{ alertMessage }}</p>
                <button class="alert-btn" @click="closeAlert">确定</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            userType: '登录',
            loginType: 'password', // 'password' 或 'sms'
            showPassword: false,
            rememberMe: false,
            isLoading: false,
            isSendingCode: false,
            codeCountdown: 0,
            showAlert: false,
            alertTitle: '',
            alertMessage: '',

            loginForm: {
                username: '',
                password: ''
            },

            smsForm: {
                phone: '',
                code: ''
            }
        };
    },

    computed: {
        codeButtonText() {
            return this.codeCountdown > 0
                ? `${this.codeCountdown}s后重发`
                : '获取验证码';
        }
    },

    methods: {
        // 切换登录方式
        switchLoginType(type) {
            this.loginType = type;
        },

        // 切换密码可见性
        togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        },

        // 处理密码登录
        async handleLogin() {
            if (!this.loginForm.username || !this.loginForm.password) {
                this.showAlertModal('登录失败', '请输入账号和密码');
                return;
            }

            this.isLoading = true;

            try {
                // 准备登录数据
                const loginData = {
                    username: this.loginForm.username,
                    password: this.loginForm.password // 实际项目中应该加密: this.$md5(this.loginForm.password)
                    // googleCode: this.loginForm.googleCode // 如果需要谷歌验证
                };
                // 发送登录请求
                console.log(loginData)
                this.$axios.post({
                    url: '/system/login',
                    data: loginData,
                    success: (res) => {
                        // this.loading = false
                        console.log('333', res)
                        this.$loading.close();

                        if (res.code == 0) {
                            this.$store.commit('username', res.data.username);
                            this.$store.commit('sessionId', res.data.sessionId);
                            this.getPushPage()
                        } else {
                            this.isLoading = false
                            this.$message.error(res.msg || '出错了')
                        }
                    },
                    error: (res) => {
                        this.isLoading = false
                        this.$message.error(res.msg || '出错了')
                    },
                })

            } catch (error) {
                this.isLoading = false;
                console.error('登录错误:', error);
                this.showAlertModal('登录失败', '登录失败，请重试');
            }
        },
        getPushPage() {
            this.$axios.get({
                url: '/system/getUserInfo',
                success: (res) => {
                    // this.loading = false
                    console.log('333', res)
                    this.$loading.close();
                    if (res.code == 0) {
                        this.$message.success('恭喜你，' + this.userType + '成功');
                        window.localStorage.setItem('adminInfo', JSON.stringify(res.data));
                        const redirectPath = this.$route.query.redirect;
                        if (res.data) {
                            this.$router.push(redirectPath ? redirectPath : this.feUrl + '/home.html');
                        } else {
                            this.$router.push(redirectPath ? redirectPath : this.feUrl + '/index.html');

                        }


                    } else {
                        this.isLoading = false
                        this.$message.error(res.msg || '出错了')
                    }
                },
                error: (res) => {
                    this.isLoading = false
                    this.$message.error(res.msg || '出错了')
                },
            })
        },
        // 处理短信登录
        async handleSmsLogin() {
            if (!this.smsForm.phone || !this.smsForm.code) {
                this.showAlertModal('登录失败', '请输入手机号和验证码');
                return;
            }

            this.isLoading = true;

            try {
                const loginData = {
                    "phone": this.smsForm.phone,
                    "smsCode": this.smsForm.code
                };
                this.$axios.post({
                    url: '/system/login',
                    data: loginData,
                    success: (res) => {
                        // this.loading = false
                        console.log('333', res)
                        this.$loading.close();
                        if (res.code == 0) {
                            this.$store.commit('username', res.data.username);
                            this.$store.commit('sessionId', res.data.sessionId);
                            this.getPushPage()
                        } else {
                            this.isLoading = false
                            this.$message.error(res.msg || '出错了')
                        }
                    },
                    error: (res) => {
                        this.isLoading = false
                        this.$message.error(res.msg || '出错了')
                    },
                })

            } catch (error) {
                this.isLoading = false;
                console.error('短信登录错误:', error);
                this.showAlertModal('登录失败', '短信登录失败，请重试');
            }
        },
        handleSmsRegister() {
            if (!this.smsForm.phone || !this.smsForm.code) {
                this.showAlertModal('注册失败', '请输入手机号和验证码');
                return;
            }

            this.isLoading = true;

            try {
                const loginData = {
                    "phone": this.smsForm.phone,
                    "smsCode": this.smsForm.code
                };
                this.$axios.post({
                    url: '/system/register',
                    data: loginData,
                    success: (res) => {
                        // this.loading = false
                        console.log('333', res)
                        this.$loading.close();
                        if (res.code == 0) {
                            this.$store.commit('username', res.data.username);
                            this.$store.commit('sessionId', res.data.sessionId);
                            this.getPushPage()
                        } else {
                            this.isLoading = false
                            this.$message.error(res.msg || '出错了')
                        }
                    },
                    error: (res) => {
                        this.isLoading = false
                        this.$message.error(res.msg || '出错了')
                    },
                })

            } catch (error) {
                this.isLoading = false;
                console.error('短信登录错误:', error);
                this.showAlertModal('登录失败', '短信登录失败，请重试');
            }
        },

        // 获取短信验证码
        async getSmsCode() {
            // 简单的手机号验证
            if (!this.smsForm.phone || this.smsForm.phone.length !== 11) {
                this.showAlertModal('验证失败', '请输入有效的手机号');
                return;
            }

            this.isSendingCode = true;

            try {
                console.log(this.smsForm.phone)
                // 发送登录请求
                this.$axios.post({
                    url: '/system/sms_code?phone=' + this.smsForm.phone,
                    success: (res) => {
                        // this.loading = false
                        console.log('333', res)

                        if (res.code == 0) {
                            // 开始倒计时
                            this.codeCountdown = 60;
                            const countdownInterval = setInterval(() => {
                                this.codeCountdown--;
                                if (this.codeCountdown <= 0) {
                                    clearInterval(countdownInterval);
                                    this.isSendingCode = false;
                                }
                            }, 1000);

                            this.showAlertModal('提示', '验证码已发送，请注意查收');
                        } else {
                            this.isLoading = false;
                            this.isSendingCode = false;
                            this.$message.error(res.msg || '出错了')

                        }
                    },
                    error: (res) => {
                        this.isLoading = false;
                        this.isSendingCode = false;
                        this.$message.error(res.msg || '出错了')
                    },
                })

            } catch (error) {
                this.isLoading = false;
                this.isSendingCode = false;
                this.showAlertModal('发送失败', '验证码发送失败，请重试');
            }
        },
        // 显示提示弹窗
        showAlertModal(title, message) {
            this.alertTitle = title;
            this.alertMessage = message;
            this.showAlert = true;
        },

        // 关闭提示弹窗
        closeAlert() {
            this.showAlert = false;
        }
    }
};
</script>

<style scoped>
/* 基础样式 */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

.login-container {
    width: 100%;
    min-height: 100vh;
    background-color: #F5F7FA;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

.login-wrapper {
    width: 100%;
    max-width: 1200px;
    background-color: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

/* 品牌区域样式 */
.brand-section {
    background: linear-gradient(135deg, #165DFF 0%, #0A3CA0 100%);
    color: #fff;
    padding: 40px;
}

.brand-header {
    display: flex;
    align-items: center;
    margin-bottom: 50px;
}

.logo {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    backdrop-filter: blur(4px);
}

.brand-name {
    font-size: 28px;
    font-weight: bold;
}

.brand-slogan {
    font-size: 32px;
    font-weight: bold;
    line-height: 1.3;
    margin-bottom: 40px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.features {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 40px;
}

.feature-card {
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    padding: 16px;
    display: flex;
    align-items: flex-start;
    backdrop-filter: blur(4px);
    transition: all 0.3s ease;
}

.feature-card:hover {
    background-color: rgba(255, 255, 255, 0.2);
}

.feature-card i {
    color: #FF7D00;
    font-size: 20px;
    margin-right: 12px;
    margin-top: 3px;
}

.feature-title {
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 5px;
}

.feature-desc {
    color: rgba(255, 255, 255, 0.8);
    font-size: 14px;
}

.brand-description {
    color: rgba(255, 255, 255, 0.8);
    font-size: 16px;
    max-width: 400px;
    margin-bottom: 60px;
}

.social-links {
    display: flex;
    align-items: center;
    gap: 20px;
}

.social-icon {
    color: rgba(255, 255, 255, 0.8);
    font-size: 20px;
    transition: color 0.3s ease;
    text-decoration: none;
}

.social-icon:hover {
    color: #fff;
}

.help-link {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-size: 14px;
    display: flex;
    align-items: center;
    transition: color 0.3s ease;
}

.help-link:hover {
    color: #fff;
}

.help-link i {
    margin-right: 5px;
}

/* 登录区域样式 */
.login-section {
    padding: 40px;
    flex: 1;
}

.login-header {
    margin-bottom: 40px;
}

.login-title {
    font-size: 28px;
    font-weight: bold;
    color: #1D2129;
    margin-bottom: 8px;
}

.login-subtitle {
    color: #4E5969;
    font-size: 16px;
}

.login-tabs {
    display: flex;
    border-bottom: 1px solid #E5E6EB;
    margin-bottom: 30px;
}

.tab-btn {
    padding: 12px 0;
    margin-right: 24px;
    background: none;
    border: none;
    font-size: 16px;
    font-weight: 500;
    color: #86909C;
    cursor: pointer;
    position: relative;
    transition: color 0.3s ease;
}

.tab-btn.active {
    color: #165DFF;
}

.tab-btn.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #165DFF;
}

.tab-btn:hover {
    color: #165DFF;
}

.login-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 30px;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.form-label-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.form-label {
    font-size: 14px;
    color: #272E3B;
    font-weight: 500;
}

.forgot-link {
    font-size: 14px;
    color: #165DFF;
    text-decoration: none;
    transition: color 0.3s ease;
}

.forgot-link:hover {
    color: #0A3CA0;
}

.input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.form-input {
    width: 100%;
    padding: 14px 16px 14px 44px;
    border: 1px solid #C9CDD4;
    border-radius: 8px;
    font-size: 16px;
    transition: all 0.3s ease;
}

.form-input:focus {
    outline: none;
    border-color: #165DFF;
    box-shadow: 0 0 0 2px rgba(22, 93, 255, 0.1);
}

.input-wrapper i:first-child {
    position: absolute;
    left: 16px;
    color: #86909C;
}

.toggle-password {
    position: absolute;
    right: 16px;
    background: none;
    border: none;
    color: #86909C;
    cursor: pointer;
    transition: color 0.3s ease;
}

.toggle-password:hover {
    color: #1D2129;
}

.form-check {
    display: flex;
    align-items: center;
    gap: 8px;
}

.check-input {
    width: 16px;
    height: 16px;
    border: 1px solid #C9CDD4;
    border-radius: 4px;
    accent-color: #165DFF;
    cursor: pointer;
}

.check-label {
    font-size: 14px;
    color: #272E3B;
    cursor: pointer;
}

.login-btn {
    padding: 14px;
    background-color: #165DFF;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    transition: background-color 0.3s ease;
    position: relative;
}

.login-btn:disabled {
    background-color: #86909C;
    cursor: not-allowed;
}

.login-btn:not(:disabled):hover {
    background-color: #0A3CA0;
}

.get-code-btn {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    padding: 6px 12px;
    background: none;
    border: 1px solid #E5E6EB;
    border-radius: 6px;
    font-size: 14px;
    color: #165DFF;
    cursor: pointer;
    transition: all 0.3s ease;
}

.get-code-btn:disabled {
    color: #C9CDD4;
    cursor: not-allowed;
}

.get-code-btn:hover:not(:disabled) {
    background-color: rgba(22, 93, 255, 0.05);
}

.register-section {
    text-align: center;
    margin-bottom: 40px;
}

.register-text {
    font-size: 14px;
    color: #4E5969;
}

.register-link {
    color: #165DFF;
    font-weight: 500;
    text-decoration: none;
    transition: color 0.3s ease;
}

.register-link:hover {
    color: #0A3CA0;
}

.other-login {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
}

.other-login-text {
    font-size: 14px;
    color: #86909C;
    position: relative;
    padding: 0 12px;
}

.other-login-text::before,
.other-login-text::after {
    content: '';
    position: absolute;
    top: 50%;
    width: 60px;
    height: 1px;
    background-color: #E5E6EB;
}

.other-login-text::before {
    left: -60px;
}

.other-login-text::after {
    right: -60px;
}

.social-login {
    display: flex;
    gap: 24px;
}

.social-btn {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    transition: background-color 0.3s ease;
}

.wechat-btn {
    background-color: rgba(7, 193, 96, 0.1);
    color: #07C160;
}

.wechat-btn:hover {
    background-color: rgba(7, 193, 96, 0.2);
}

.qq-btn {
    background-color: rgba(18, 150, 219, 0.1);
    color: #1296DB;
}

.qq-btn:hover {
    background-color: rgba(18, 150, 219, 0.2);
}

.weibo-btn {
    background-color: rgba(228, 64, 95, 0.1);
    color: #E4405F;
}

.weibo-btn:hover {
    background-color: rgba(228, 64, 95, 0.2);
}

/* 加载动画 */
.loading-spinner {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top-color: white;
    animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

/* 弹窗样式 */
.alert-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.alert-content {
    background-color: white;
    border-radius: 12px;
    padding: 30px;
    width: 90%;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    text-align: center;
}

.alert-title {
    font-size: 20px;
    font-weight: bold;
    color: #1D2129;
}

.alert-message {
    font-size: 16px;
    color: #4E5969;
}

.alert-btn {
    padding: 10px 24px;
    background-color: #165DFF;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.alert-btn:hover {
    background-color: #0A3CA0;
}

/* 图标样式 */
[class^="icon-"] {
    display: inline-block;
    width: 24px;
    height: 24px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}

.icon-rocket {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.93c-2.11 0-3.96-1.07-5-2.93 1.04 1.86 2.89 3 5 3s3.96-1.07 5-3c-1.04 1.86-2.89 3-5 3z'/%3E%3C/svg%3E");
}

.icon-line-chart {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23FF7D00'%3E%3Cpath d='M21 18c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1zM4.41 22.91L3 21.5l8-8 4 4 8-16-1.41-1.41L12 15.09 6.41 9.5 4.41 11.5l4 4-4 4z'/%3E%3C/svg%3E");
}

.icon-balance-scale {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23FF7D00'%3E%3Cpath d='M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7 17c-1.66 0-3-1.34-3-3 0-2 3-5.4 3-5.4s3 3.4 3 5.4c0 1.66-1.34 3-3 3zm13.71-9.37l-1.34-1.34a.996.996 0 0 0-1.41 0L12 10.25 9.05 7.31a.996.996 0 0 0-1.41 0L4.29 8.66a.996.996 0 0 0 0 1.41L12 13.17l7.71 7.71a.996.996 0 0 0 1.41 0l1.34-1.34a.996.996 0 0 0 0-1.41L13.41 12l6.3-6.32c.38-.38.38-1.02 0-1.41z'/%3E%3C/svg%3E");
}

.icon-sitemap {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23FF7D00'%3E%3Cpath d='M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z'/%3E%3C/svg%3E");
}

.icon-bar-chart {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23FF7D00'%3E%3Cpath d='M21 3H3v18h18V3zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z'/%3E%3C/svg%3E");
}

.icon-weibo {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='currentColor'%3E%3Cpath d='M18.22 5.24c1.17.6 2.15 1.68 2.75 3.03-.95.56-1.99.94-3.09 1.11.25-.47.44-.96.55-1.47.11-.52.16-.95.16-1.67-.01-.16-.01-.32-.02-.48.65-.47 1.2-1.08 1.6-1.78zm-2.05 6.37c-1.46-.09-2.8-.58-3.89-1.38.05.47.08.94.08 1.42 0 1.7-.89 3.22-2.22 4.16-.42-.07-.83-.16-1.23-.28-.12.42-.24.83-.38 1.23.84-.26 1.63-.65 2.3-1.16.68-.51 1.24-1.14 1.67-1.87.43.6 1 1.12 1.62 1.55.61-.13 1.19-.34 1.74-.63-.19-.46-.36-.92-.52-1.39.43-.27.82-.6 1.16-.99-.31.19-.65.35-1.01.47zM10.5 8.6c.36-.6.63-1.24.8-1.91-.74.41-1.55.68-2.4.78-.13-.42-.25-.84-.36-1.27.81-.25 1.58-.39 2.37-.41-.01.31-.01.63-.01.95 0 .55.05 1.09.15 1.61zm-4.7 6.84c-.07-.52-.11-1.05-.11-1.59 0-1.63.69-3.11 1.84-4.12-.05.53-.08 1.06-.08 1.6 0 1.32.43 2.54 1.14 3.53-.49.15-.99.27-1.5.37-.32-.46-.6-1-.85-1.51zm16.21-9.66c-.28.5-.5 1.03-.67 1.58-.17-.55-.39-1.07-.65-1.56.33-.48.62-.98.86-1.5.01.01 0 .01 0 .02-.3.46-.57.95-.8 1.46zM3 5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5zm16 13H5V5h14v13z'/%3E%3C/svg%3E");
}

.icon-wechat {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='currentColor'%3E%3Cpath d='M7.97 19.2c-2.18-.26-3.47-1.45-3.97-2.49-.5-.99-.45-2.15.36-3.56.36-.61.95-1.53 1.35-2.14.4-.61.74-1.17 1.05-1.67.08-.13.15-.26.23-.38H5.2c-.55 0-1-.45-1-1s.45-1 1-1h6.66c.55 0 1-.45 1-1 0-.28-.22-.5-.5-.5h-7.16c-1.1 0-2 .9-2 2 0 .38.11.73.31 1.03.66 1.05 1.76 2.59 2.5 3.55-.16.19-.32.38-.47.58-.53.66-.87 1.44-.94 2.27-.1 1.1.6 2.11 1.56 2.54.43.19.88.29 1.34.31.03 0 .06 0 .09-.01.94-.06 1.84-.38 2.59-1.03.75-.65 1.07-1.57 1.01-2.52-.03-.07-.06-.14-.09-.21.82.22 1.68.33 2.56.33.55 0 1-.45 1-1 0-.55-.45-1-1-1-1.5 0-2.93-.52-4.09-1.43.04-.27.07-.55.07-.83 0-.09 0-.17-.01-.26.95.3 1.83.46 2.75.46.55 0 1-.45 1-1s-.45-1-1-1c-1.46 0-2.8-.42-3.93-1.16.34.65.62 1.33.82 2.04.36.1.72.19 1.08.28-.41.36-.79.74-1.13 1.14-.34.4-.65.81-.93 1.23-.58-.01-1.16-.12-1.72-.34-.57.95-.57 2.05-.01 3.05.54.96 1.47 1.67 2.56 1.97 1.1.3 2.25.11 3.26-.56.77-.51 1.38-1.28 1.74-2.21.36.54.85 1.01 1.43 1.36.59.36 1.25.55 1.93.55.55 0 1-.45 1-1 0-.55-.45-1-1-1-.61 0-1.18-.15-1.69-.43.13.47.2 1 .2 1.53 0 1.65-.86 3.12-2.18 4.06-.39-.05-.79-.11-1.19-.19-.11.42-.23.84-.35 1.26.82-.24 1.59-.61 2.26-1.11.67-.51 1.21-1.14 1.63-1.87.42.6 1 1.12 1.62 1.55.62-.13 1.2-.34 1.75-.63-.18-.46-.35-.92-.51-1.39.43-.27.82-.6 1.16-.99-.31.19-.65.35-1.01.47z'/%3E%3C/svg%3E");
}

.icon-question-circle {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='currentColor'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm0-4h-2V7h2v8z'/%3E%3C/svg%3E");
}

.icon-user {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2386909C'%3E%3Cpath d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'/%3E%3C/svg%3E");
}

.icon-lock {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2386909C'%3E%3Cpath d='M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z'/%3E%3C/svg%3E");
}

.icon-mobile {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2386909C'%3E%3Cpath d='M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z'/%3E%3C/svg%3E");
}

.icon-shield {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2386909C'%3E%3Cpath d='M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.93c-2.11 0-3.96-1.07-5-2.93 1.04 1.86 2.89 3 5 3s3.96-1.07 5-3c-1.04 1.86-2.89 3-5 3z'/%3E%3C/svg%3E");
}

.icon-eye {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2386909C'%3E%3Cpath d='M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z'/%3E%3C/svg%3E");
}

.icon-eye-slash {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2386909C'%3E%3Cpath d='M17.94 17.94c-.22-.03-.44-.06-.67-.09l-1.11-1.11c1.52-1.27 2.7-2.81 3.53-4.59.41-.84.64-1.75.64-2.69a10.16 10.16 0 0 0-3.9-7.83c-1.11-.65-2.3-.99-3.5-.99-1.95 0-3.73.7-5.12 1.88l1.41 1.41C9.5 5.21 10.74 5 12 5c2.21 0 4.2.8 5.66 2.14 1.41 1.3 2.2 3.02 2.2 4.86 0 1.09-.28 2.14-.77 3.06l1.41 1.41c.84-.7 1.54-1.56 2.08-2.53zM1.11 1.11l1.41 1.41C2.16 4.25 2 6.15 2 8c0 4.28 2.99 7.86 7 8.83l1.42 1.42c-1.43.13-2.94.2-4.42.2-1.5 0-2.99-.2-4.42-.59-.23-.05-.45-.07-.67-.09L1.11 22.89 2.83 24l18.78-18.78-1.72-1.72L1.11 1.11zM7.5 11.5l1.09 1.09c-.23.12-.46.26-.69.41L7.5 11.5zm3.68 3.68l1.09 1.09c-1.03.31-2.12.48-3.27.48-.35 0-.69-.02-1.03-.06l1.41-1.41c.35.05.71.08 1.08.08 1.09 0 2.12-.17 3.07-.49zM12 19c-3.86 0-7-3.4-7-7.65l3.5 3.5c.15.23.3.46.48.69L7.5 11.5 10 14l1.5-1.5-2.5-2.5 1.41-1.41 4.95 4.95c.39-.49.7-1.06.9-1.66l1.41 1.41c-.41.96-.92 1.86-1.53 2.66L12 19z'/%3E%3C/svg%3E");
}

.icon-arrow-right {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M8.59 16.58L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.42z'/%3E%3C/svg%3E");
}

.icon-qq {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='currentColor'%3E%3Cpath d='M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0zm-.31 19.34c-3.62-.74-6.48-3.84-6.69-7.69.34-4.12 3.86-7.42 7.98-7.42 4.13 0 7.63 3.3 7.63 7.42-.22 3.85-3.07 6.95-6.69 7.69-.15.03-.31.04-.46.04-.16 0-.31-.01-.46-.04zM10.15 14.02c.05-.59.41-1.06.98-1.06h2.76c.57 0 .93.47.98 1.06l.21 1.28c.05.32-.23.6-.56.6h-3.84c-.33 0-.61-.28-.56-.6l.21-1.28zm4.5-5.69c-.61 0-1.1-.49-1.1-1.1 0-.61.49-1.1 1.1-1.1s1.1.49 1.1 1.1c0 .61-.49 1.1-1.1 1.1zm-6.7 0c-.61 0-1.1-.49-1.1-1.1 0-.61.49-1.1 1.1-1.1s1.1.49 1.1 1.1c0 .61-.49 1.1-1.1 1.1z'/%3E%3C/svg%3E");
}

/* 响应式样式 */
@media (min-width: 768px) {
    .login-wrapper {
        flex-direction: row;
        height: 90vh;
        max-height: 800px;
    }

    .brand-section,
    .login-section {
        flex: 1;
    }
}

@media (max-width: 767px) {
    .brand-section {
        display: none;
    }

    .brand-slogan {
        font-size: 24px;
    }

    .other-login-text::before,
    .other-login-text::after {
        width: 40px;
    }

    .other-login-text::before {
        left: -40px;
    }

    .other-login-text::after {
        right: -40px;
    }
}
</style>
